var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCourseBiology = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 98,
    viewBox: "0 0 104 98",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 98,
    rx: 10,
    fill: "url(#paint0_linear_3333_313365)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5079 27.0995L74.618 30.5258C74.8543 30.6584 74.9998 30.9035 74.9998 31.1688V38.0274C74.9998 38.2927 74.8543 38.5378 74.618 38.6704L68.8898 41.8851V45.7347H67.3622V41.8851L62.3268 39.0579L61.0284 40.3201L59.9484 39.2703L61.2522 38.0029V31.1933L58.4209 28.4411L59.5001 27.3964L62.326 30.1435L67.7441 27.0995C67.9804 26.9668 68.2716 26.9668 68.5079 27.0995ZM68.126 40.5992L73.4723 37.599V31.5972L68.126 28.597L62.7797 31.5972V37.599L68.126 40.5992Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.361 59.2606V66.347L45 68.0499L43.9504 69.1424L42.3174 67.4426L37.0517 70.6103C36.822 70.7483 36.539 70.7483 36.3094 70.6103L30.3711 67.0416C30.1415 66.9036 30 66.6485 30 66.3725V59.2351C30 58.9591 30.1415 58.704 30.3711 58.566L35.9382 55.2206V52.7598H37.4228V55.2206L42.3167 58.1627L43.5785 56.8492L44.6281 57.9417L43.361 59.2606ZM36.6805 69.0489L41.8765 65.9267V59.6809L36.6805 56.5587L31.4846 59.6809V65.9267L36.6805 69.0489Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6234 55.4354L72.6312 53.4316L71.5824 52.3849L69.5798 54.3835L64.6898 51.5647V45.0721L66.6976 43.0683L65.6488 42.0216L63.6462 44.0202L58.7562 41.2014V37.3633H57.2728V41.2014L52.081 44.1927L46.8891 41.2014V34.7088L49.6386 31.9648L48.5898 30.9181L45.8455 33.6569L40.9555 30.8381V27H39.4721V30.8381L34.5814 33.6562L32.2079 31.2874L31.1599 32.3349L33.5385 34.7088V41.4983L30.7891 44.2423L31.8378 45.289L34.5821 42.5501L39.4721 45.3689V51.8616L37.4643 53.8654L38.5131 54.9121L40.5157 52.9134L45.4057 55.7323V59.5704H46.8891V55.7323L52.081 52.741L57.2728 55.7323V62.2249L55.6359 63.8586L56.6847 64.9053L58.3164 63.2767L63.2064 66.0956V69.9337H64.6898V66.0956L69.5806 63.2775L71.2123 64.906L72.2611 63.8593L70.6234 62.2249V55.4354ZM40.2138 44.0869L35.0219 41.0956V35.1115L40.2138 32.1202L45.4057 35.1115V41.0956L40.2138 44.0869ZM46.1474 54.4502L51.3393 51.4589V45.4748L46.1474 42.4835L40.9555 45.4748V51.4589L46.1474 54.4502ZM58.0145 54.4502L52.8227 51.4589V45.4748L58.0145 42.4835L63.2064 45.4748V51.4589L58.0145 54.4502ZM63.9481 64.8135L69.14 61.8222V55.8381L63.9481 52.8468L58.7562 55.8381V61.8222L63.9481 64.8135Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3333_313365",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80BDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69A8E2"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCourseBiology, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CourseBiology.9ab08e0e.svg";
export { ForwardRef as ReactComponent };